export const ERROR_MESSAGES: Record<string, string> = {
  // Authentication errors
  'AUTH_001': 'Invalid credentials. Please check your email and password.',
  'AUTH_002': 'MFA code expired. Please request a new code.',
  'AUTH_003': 'Invalid MFA code. Please try again.',
  'AUTH_004': 'Session expired. Please login again.',
  'AUTH_005': 'Account locked due to multiple failed attempts.',
  
  // Permission errors
  'PERM_001': 'You do not have permission to perform this action.',
  'PERM_002': 'This action requires Super Admin privileges.',
  
  // Rate limiting
  'RATE_001': 'Too many requests. Please wait before trying again.',
  
  // Payment errors
  'PAY_001': 'Payment refund failed. Please contact technical support.',
  'PAY_002': 'Payment not found or already refunded.',
  
  // Trial errors
  'TRIAL_001': 'Trial period has already been assigned to this merchant.',
  'TRIAL_002': 'Invalid trial duration. Must be between 1 and 30 days.',
  
  // Merchant errors
  'MERCHANT_001': 'Merchant verification failed. Please review KYC documents.',
  'MERCHANT_002': 'Merchant already verified.',
  
  // Generic errors
  'GENERIC_001': 'An unexpected error occurred. Please try again.',
  'NETWORK_001': 'Network error. Please check your connection.',
  'TIMEOUT_001': 'Request timed out. Please try again.',
}

/**
 * Get user-friendly error message from error code
 */
export const getErrorMessage = (errorCode: string): string => {
  return ERROR_MESSAGES[errorCode] || ERROR_MESSAGES['GENERIC_001']
}

/**
 * Extract the most specific human-readable message from an axios error.
 * Handles both `{ message }` and `{ error: { message } }` response shapes.
 */
export const getApiErrorMessage = (err: any, fallback = ERROR_MESSAGES['GENERIC_001']): string => {
  if (!err?.response?.data) return fallback
  const data = err.response.data
  return data.error?.message || data.message || fallback
}
